export default {"src":"/_next/static/media/order.5474620f.svg","height":24,"width":24};